import { getHttpClient } from '../../api/axiosInstance'
import { useQuery } from '@tanstack/react-query'

const loadCacheLanguagePair = async () => {
  const apiClient = getHttpClient()

  const response = await apiClient.get('/public/cache/v1/language-pairs')

  return response.data
}

export const key = 'cache.languagePair'

export const useCacheLanguagePair = () => {
  return useQuery({
    queryKey: [key],
    queryFn: loadCacheLanguagePair,
    refetchOnWindowFocus: false,
    staleTime: 60 * (60 * 1000), // 60 minutes
    cacheTime: 60 * (60 * 1000) // 60 minutes
  })
}

/**
 * Selectors for RAW data
 */
const getLanguagePairs = (data) => (data?.languagePairs || [])

/**
 * Generic function to create an array indexed by id
 *
 * TODO:
 *    - Should be a function ? ( errores when ids outside of its domain )
 *    - Should be in the reducer ?
 */
const getById = (list) => {
  return list.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {})
}

/**
 * Selectors for display data for a specific ID
 */
export const getLanguagePairsById = (state) => getById(getLanguagePairs(state))

export const getLanguagePairsForSelect = (state) => {
  const list = getLanguagePairs(state).filter((item) => item.active)
  return (list || []).map((item) => {
    return { ...item, value: item.id, label: item.name }
  })
}
